import { Link, FileText, Music, Video, Film, Type, Wifi, Contact, Mail, Phone, MessageSquare, Image } from "lucide-react";

// Each type defines: label, icon, category (dynamic file/link vs static content), and whether it needs upload
export const QR_TYPES = {
  url: { label: "Website URL", icon: Link, hint: "Link to any web page", kind: "link" },
  pdf: { label: "PDF Document", icon: FileText, hint: "Upload or link a PDF", kind: "file", accept: ".pdf" },
  audio: { label: "Audio (MP3)", icon: Music, hint: "Upload or link audio", kind: "file", accept: "audio/*" },
  video: { label: "Video (MP4/AVI)", icon: Video, hint: "Upload or link video", kind: "file", accept: "video/*" },
  image: { label: "Image", icon: Image, hint: "Upload or link an image", kind: "file", accept: "image/*" },
  vcard: { label: "vCard Contact", icon: Contact, hint: "Digital business card", kind: "static" },
  wifi: { label: "WiFi Access", icon: Wifi, hint: "Auto-connect to WiFi", kind: "static" },
  text: { label: "Plain Text", icon: Type, hint: "Any text message", kind: "static" },
  email: { label: "Email", icon: Mail, hint: "Pre-filled email", kind: "static" },
  phone: { label: "Phone Call", icon: Phone, hint: "Tap to call", kind: "static" },
  sms: { label: "SMS", icon: MessageSquare, hint: "Pre-filled text message", kind: "static" },
};

export const DEFAULT_DESIGN = {
  fgColor: "#0A0A0B",
  bgColor: "#FFFFFF",
  dotType: "rounded",
  cornerSquareType: "extra-rounded",
  cornerDotType: "dot",
  logo: null,
};

export const DOT_TYPES = ["square", "dots", "rounded", "extra-rounded", "classy", "classy-rounded"];
export const CORNER_SQUARE_TYPES = ["square", "dot", "extra-rounded"];
export const CORNER_DOT_TYPES = ["square", "dot"];

// Compute a scannable preview string from the payload (used before the QR is saved)
export function computePreviewData(type, payload) {
  const p = payload || {};
  switch (type) {
    case "url":
      return p.url || "https://qrflux.app";
    case "pdf":
    case "audio":
    case "video":
    case "image":
      return p.url || "https://qrflux.app/file";
    case "text":
      return p.text || "Sample text";
    case "email":
      return `mailto:${p.to || ""}?subject=${encodeURIComponent(p.subject || "")}&body=${encodeURIComponent(p.body || "")}`;
    case "phone":
      return `tel:${p.phone || ""}`;
    case "sms":
      return `sms:${p.phone || ""}?body=${encodeURIComponent(p.message || "")}`;
    case "wifi":
      return `WIFI:T:${p.encryption || "WPA"};S:${p.ssid || ""};P:${p.password || ""};;`;
    case "vcard":
      return `BEGIN:VCARD\nVERSION:3.0\nFN:${p.firstName || ""} ${p.lastName || ""}\nTEL:${p.phone || ""}\nEMAIL:${p.email || ""}\nEND:VCARD`;
    default:
      return "https://qrflux.app";
  }
}
